import Fantasy from '@/views/fantasy/Index'

export default [
  {
    path: ':clientId/fantasy',
    name: 'fantasy.index',
    component: Fantasy,
    meta: { featureKey: 'fantasy' }
  }
]
